import { render, staticRenderFns } from "./KBankPayment.vue?vue&type=template&id=1c8fc91c&scoped=true"
import script from "./KBankPayment.vue?vue&type=script&lang=js"
export * from "./KBankPayment.vue?vue&type=script&lang=js"
import style0 from "./KBankPayment.vue?vue&type=style&index=0&id=1c8fc91c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8fc91c",
  null
  
)

export default component.exports